import { render } from "./OptimizedManifestMap.vue?vue&type=template&id=f1d1e4e8&scoped=true"
import script from "./OptimizedManifestMap.vue?vue&type=script&lang=js"
export * from "./OptimizedManifestMap.vue?vue&type=script&lang=js"

import "./OptimizedManifestMap.vue?vue&type=style&index=0&id=f1d1e4e8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d1e4e8"]])

export default __exports__